import type { RootState } from 'store'
import type { FieldName, MerchantValues } from './types'
import validators from './validators'

export const getValue =
  <T extends FieldName>(field: T) =>
  (state: RootState): MerchantValues[T] => {
    return state.merchant.values[field]
  }

export const getError =
  (field: FieldName) =>
  (state: RootState): string | null => {
    return state.merchant.errors[field] ?? null
  }

export const getIsFormValid = (state: RootState) => {
  for (const checking of Object.values(state.merchant.checking)) {
    if (checking) return false
  }

  for (const error of Object.values(state.merchant.errors)) {
    if (error) return false
  }

  const values = state.merchant.values
  for (const field of Object.keys(values)) {
    const error = validators[field]?.(values)
    if (error) return false
  }

  return true
}
